import * as React from "react";
const SvgJavascript = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.5 12a1.93 1.93 0 0 1-1.417-.583A1.93 1.93 0 0 1 .5 10V8.667h2V10h2V4h2v6q0 .834-.583 1.417A1.93 1.93 0 0 1 4.5 12zm7.333 0a1.3 1.3 0 0 1-.95-.383 1.3 1.3 0 0 1-.383-.95V9.333h2V10h2.667V8.667H9.833a1.3 1.3 0 0 1-.95-.384 1.3 1.3 0 0 1-.383-.95v-2q0-.566.383-.95A1.3 1.3 0 0 1 9.833 4h4q.567 0 .95.383.384.384.384.95v1.334h-2V6H10.5v1.333h3.333q.567 0 .95.384.384.383.384.95v2q0 .566-.384.95a1.3 1.3 0 0 1-.95.383z"
    />
  </svg>
);
export default SvgJavascript;
